// component
import SvgColor from '../../../components/svg-color';
import Iconify from '../../../components/iconify';

// ----------------------------------------------------------------------

const icon = (name) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const navConfig = [
  {
    title: 'home',
    path: '/project/home',
    icon: <Iconify icon="eva:home-fill" sx={{ width: 1, height: 1 }} />,
  },
  {
    title: 'feasibility',
    path: '/project/feasibility',
    icon: <Iconify icon="eva:checkmark-circle-2-fill" sx={{ width: 1, height: 1 }} />,
  },
  {
    title: 'baseline',
    path: '/project/baseline',
    icon: <Iconify icon="eva:activity-fill" sx={{ width: 1, height: 1 }} />,
  },
  {
    title: 'monitoring',
    path: '/project/monitoring',
    icon: <Iconify icon="eva:bar-chart-fill" sx={{ width: 1, height: 1 }} />,
  },

  // --- Tools ---
  {
    subheader: 'Tools',
  },
  {
    title: 'map & sites',
    path: '/project/site-visit',
    icon: <Iconify icon="eva:map-fill" sx={{ width: 1, height: 1 }} />,
  },
  {
    title: 'stratification',
    path: '/project/stratification',
    icon: <Iconify icon="eva:layers-fill" sx={{ width: 1, height: 1 }} />,
  },
  {
    title: 'sampling',
    path: '/project/sampling',
    icon: icon('ic_sampling'),
  },
  {
    title: 'capture',
    path: '/project/capture',
    icon: <Iconify icon="eva:camera-fill" sx={{ width: 1, height: 1 }} />,
  },
  {
    title: 'evidence review',
    path: '/project/evidence-review',
    icon: <Iconify icon="eva:checkmark-square-fill" sx={{ width: 1, height: 1 }} />,
  },
  {
    title: 'library',
    path: '/project/library',
    icon: <Iconify icon="eva:folder-fill" sx={{ width: 1, height: 1 }} />,
  },

  // --- Demos ---
  {
    subheader: 'Demos',
  },
  {
    title: 'KKL Carbon Model',
    path: '/project/kkl-demo',
    icon: <Iconify icon="eva:trending-up-fill" sx={{ width: 1, height: 1 }} />,
  },

  // --- Registry ---
  {
    subheader: 'Registry',
  },
  {
    title: 'sites',
    path: '/project/registry/sites',
    icon: <Iconify icon="eva:pin-fill" sx={{ width: 1, height: 1 }} />,
  },
  {
    title: 'stakeholders',
    path: '/project/registry/stakeholders',
    icon: <Iconify icon="eva:people-fill" sx={{ width: 1, height: 1 }} />,
  },
  {
    title: 'grievances',
    path: '/project/registry/grievances',
    icon: <Iconify icon="eva:alert-triangle-fill" sx={{ width: 1, height: 1 }} />,
  },
];

export default navConfig;
